import { JoinClassName } from '../utils/cssHelper';
import CSSStyle from './index.module.css';
import React, { useState, useCallback, useEffect, PropsWithChildren, useContext } from "react";
import { useElements, useStripe } from '@stripe/react-stripe-js';
import { PaymentRequest, PaymentMethod, PaymentRequestPaymentMethodEvent, PaymentRequestItem, StripeError } from '@stripe/stripe-js';
import { CardPaymentMethodInfo, ChowbusStripePaymentContextData, LOCAL, PaymentRequestInfo, PaymentType, PromiseResult, StripPaymentIntentResult } from '../model';
import Logger from '../utils/consolelog';
import PaymentMethodSelector from '../PaymentMethodSelector';
import { CreditCardPaymentPanel } from '../CreditCardPaymentPanel';
import { ApplyPaymentPanel } from '../ApplyPaymentPanel';
import { ChowbusStripePaymentContext } from '../ChowbusStripePaymentProvider';


function retrieveCardPaymenMethodInfo(paymentMethod: PaymentMethod, paymentType: PaymentType): CardPaymentMethodInfo {
    let { id, card, customer, metadata } = paymentMethod;
    return {
        paymentMethodId: id,
        card: card as PaymentMethod.Card,
        customer,
        metadata,
        paymentType,
    }
}

export type StripePaymentProps = PropsWithChildren<{
    interfaceLocal: LOCAL;
    paymentCheckTime?: number;
    checkPaymentPayStatus: (paymentId: string, orderId: string) => Promise<boolean>;
    cancelPayment: (paymentId: string) => Promise<PromiseResult>;
    createStripePaymentIntent: (payAmount: number) => Promise<StripPaymentIntentResult>;
    onPaymentTypeActived: (paymentType: PaymentType) => void;
    registerPaymentRequest: (paymentId: string, paymentIntentId: string, createdAt: number,//时间戳,
        payAmount: Number,
        cardPaymentMethodInfo: CardPaymentMethodInfo,

    ) => Promise<PromiseResult>;
    onPaymentResult: (error: 'PamentStatusCheckTimeout' | StripeError | null, paymentInfo: {
        paymentType: PaymentType,
        paymentId: string,
        orderId: string,
    }, payerInfo?: {
        payerName?: string;
        payerEmail?: string;
        payerPhone?: string;
    }) => void;

    doPaymentBizEnable: () => Promise<boolean>;
}>;

const LogPrefix = "==StripePayment==";
export function StripePayment(props: StripePaymentProps) {
    let {
        interfaceLocal: local,
    } = props;

    let { browserPaymentRequestInitialized,
        paymentRequestInfo: _paymentRequestInfo_,
        cardPaymentMethodInfo,
        onCreditCardMethodRequest,
        onCancelCreditCardMethodRequest,
        showPaymentDoing,
        closePaymentDoing, } = useContext<ChowbusStripePaymentContextData>(ChowbusStripePaymentContext);

    let paymentRequestInfo = _paymentRequestInfo_ as PaymentRequestInfo;

    Logger(LogPrefix);
    const stripe = useStripe();
    const elements = useElements();

    let [creditCardReady, setCreditCardReady] = useState<CardPaymentMethodInfo | null>(cardPaymentMethodInfo);
    let [showPaymentMethodOptions, setShowPaymentMethodOptions] = useState<boolean>(false);

    useEffect(() => {
        setCreditCardReady(cardPaymentMethodInfo);
    }, [cardPaymentMethodInfo]);

    // Logger(LogPrefix, '==payButtonEnable==', payButtonEnable, browserPaymentRequestInitialized, applePayIsSupport, cardPaymentMethodInfo);
    let initStripPaymentTimeoutCheck = useCallback(() => {
        return {
            stop: () => {
                // checkTimer && clearTimeout(checkTimer);
            },
            start: async (paymentId: string, orderId: string, payerInfo?: {
                payerName?: string;
                payerEmail?: string;
                payerPhone?: string;
            }) => {
                showPaymentDoing();
                let checkStatusLogic = async () => {
                    let result = await props.checkPaymentPayStatus(paymentId, orderId);
                    return result;
                };
                let paymentDone = await checkStatusLogic();
                closePaymentDoing();
                if (paymentDone) {
                    props.onPaymentResult(null, { paymentType: PaymentType.UNKNOW, orderId: orderId, paymentId: paymentId }, payerInfo);
                } else {
                    props.onPaymentResult('PamentStatusCheckTimeout', { paymentType: PaymentType.UNKNOW, orderId: orderId, paymentId: paymentId }, payerInfo);
                }

            },
        };
        // eslint-disable-next-line
    }, [showPaymentDoing, closePaymentDoing]);

    let buildRequestPaymentInfor = useCallback(() => {
        // let smartOrderingSetting = globaldatastore.smartOrderingSetting as SmartOrderingSetting;
        // let orderForView = order as OrderForView;
        let { billTotalDisplayItem, billDetailDisplayItems } = paymentRequestInfo as PaymentRequestInfo;

        return {
            total: billTotalDisplayItem,
            displayItems: [...billDetailDisplayItems].filter((item: any) => {
                return !!item;
            }) as PaymentRequestItem[],
        };
        // eslint-disable-next-line 
    }, [paymentRequestInfo]);


    let onApplyPayPayment = useCallback(async () => {
        if (browserPaymentRequestInitialized && browserPaymentRequestInitialized.paymentRequest) {
            let paymentRequest = browserPaymentRequestInitialized.paymentRequest;
            let paymentEnable = await props.doPaymentBizEnable();
            if (!paymentEnable) return;
            paymentRequest && paymentRequest.show();
        }
    }, [browserPaymentRequestInitialized, props]);


    let onAddCreditCard = useCallback(async () => {
        let paymentEnable = await props.doPaymentBizEnable();
        if (!paymentEnable) return;
        onCreditCardMethodRequest && onCreditCardMethodRequest();

    }, [onCreditCardMethodRequest, props]);

    let onSelectPayemntMethod = useCallback(async () => {
        onCreditCardMethodRequest && onCreditCardMethodRequest();
    }, [onCreditCardMethodRequest]);


    let onDoCreditCardPayment = useCallback(async (creditCardReady: CardPaymentMethodInfo) => {
        let paymentEnable = await props.doPaymentBizEnable();
        if (!paymentEnable) return;
        if (!elements || !stripe) {
            return;
        }
        // let isSeparatePayment = !fullPaymentModel;
        let { start: startChecking, stop: stopChecking } = initStripPaymentTimeoutCheck();


        let { payAmount, orderId } = paymentRequestInfo as PaymentRequestInfo;
        let paymentId = '';
        try {
            showPaymentDoing();
            let reuslt = await props.createStripePaymentIntent(payAmount);
            paymentId = reuslt.data?.paymentId;
            stopChecking();
            // onPaymentResult(false, { paymentType: PaymentType.UNKNOW, paymentId, orderId: orderId });
            paymentId = reuslt.data.paymentId;
            let paymentIntent = reuslt.data.paymentIntent;
            let { client_secret, id: paymentIntentId, created } = paymentIntent;
            //create paymentinfor to POS for webhook from stipper
            await props.registerPaymentRequest(paymentId, paymentIntentId, created, payAmount, creditCardReady as CardPaymentMethodInfo);

            const { error: confirmCardPaymentError } = await stripe.confirmCardPayment(
                client_secret as string,
                {
                    payment_method: (creditCardReady as CardPaymentMethodInfo).paymentMethodId
                }
            );
            closePaymentDoing();
            if (confirmCardPaymentError) {
                stopChecking();
                await props.cancelPayment(paymentId);
                props.onPaymentResult(confirmCardPaymentError, { paymentType: PaymentType.UNKNOW, paymentId: paymentId, orderId: orderId });
                return;
            } else {
                startChecking(paymentId, orderId);
            }

        } catch (error) {
            closePaymentDoing();
            stopChecking();
            props.onPaymentResult(error, { paymentType: PaymentType.UNKNOW, paymentId: paymentId, orderId: orderId });
        }



    }
        // eslint-disable-next-line 
        , [stripe, elements, props, initStripPaymentTimeoutCheck, paymentRequestInfo, closePaymentDoing, showPaymentDoing]);

    useEffect(() => {
        let paymentRequest: PaymentRequest | null = null;
        if (!browserPaymentRequestInitialized || !browserPaymentRequestInitialized.paymentRequest || !stripe) {
            return;
        }
        paymentRequest = browserPaymentRequestInitialized.paymentRequest;
        let { payAmount, orderId } = paymentRequestInfo;
        let onpaymentmethod = async (ev: PaymentRequestPaymentMethodEvent) => {
            // let isSeparatePayment = !fullPaymentModel;
            let paymentId = '';
            let { start: startChecking } = initStripPaymentTimeoutCheck();
            try {
                let reuslt = await props.createStripePaymentIntent(payAmount);
                paymentId = reuslt.data.paymentId;
                let paymentIntentForClientSecret = reuslt.data.paymentIntent;
                let { client_secret, id: paymentIntentId, created } = paymentIntentForClientSecret;
                let { payerName, payerEmail, payerPhone } = ev;
                let cardPaymentMethodInfo = retrieveCardPaymenMethodInfo(ev.paymentMethod, PaymentType.Wallet_ApplePay)
                await props.registerPaymentRequest(paymentId, paymentIntentId, created, payAmount, cardPaymentMethodInfo);
                const { error: confirmCardPaymentError } = await stripe.confirmCardPayment(
                    client_secret as string,
                    { payment_method: ev.paymentMethod.id },
                );
                if (confirmCardPaymentError) {
                    ev.complete('fail');
                    await props.cancelPayment(paymentId);
                    props.onPaymentResult(confirmCardPaymentError, { paymentType: PaymentType.UNKNOW, paymentId: paymentId, orderId: orderId });
                } else {
                    ev.complete('success');
                    startChecking(paymentId, orderId, {
                        payerName, payerEmail, payerPhone
                    });
                }

            } catch (error) {
                ev.complete('fail');
                props.onPaymentResult(error, { paymentType: PaymentType.UNKNOW, paymentId: paymentId, orderId: orderId });
                return;
            }
        };

        paymentRequest.on('paymentmethod', onpaymentmethod);

        return () => {
            paymentRequest && paymentRequest.off('paymentmethod', onpaymentmethod);
        };

        // eslint-disable-next-line 
    }, [stripe, browserPaymentRequestInitialized, props, initStripPaymentTimeoutCheck]);


    useEffect(() => {
        if (browserPaymentRequestInitialized) {
            let paymentRequest = browserPaymentRequestInitialized.paymentRequest;
            paymentRequest && paymentRequest.update(buildRequestPaymentInfor());
        }

    }, [buildRequestPaymentInfor, browserPaymentRequestInitialized]);

    useEffect(() => {
        let paymnetType = PaymentType.UNKNOW;
        let { applePayIsSupport, googlePayIsSupport, paymentRequest } = browserPaymentRequestInitialized || { applePayIsSupport: false, googlePayIsSupport: false, paymentRequest: null };
        if (creditCardReady) {
            paymnetType = PaymentType.BankCard_CreditCard;
        } else if (paymentRequest) {
            if (applePayIsSupport) {
                paymnetType = PaymentType.Wallet_ApplePay;
            } else if (googlePayIsSupport) {
                paymnetType = PaymentType.Wallet_GooglePay;
            }
        }
        Logger(LogPrefix, 'paymnetType>>>', paymnetType, applePayIsSupport, googlePayIsSupport);
        // setActivedPaymentType(paymnetType);
        props.onPaymentTypeActived(paymnetType);

    }, [browserPaymentRequestInitialized, props]);


    let onPaymentMethodChanged = useCallback((type: 'ApplyPay' | 'Card') => {
        setShowPaymentMethodOptions(false);
        if (type === 'ApplyPay') {
            setCreditCardReady(null);
        } else {
            //Card ,show new cread card 
            // setShowCreditCardEntry(true);
        }
    }, []);

    let onCancelPaymentMethodSelector = useCallback(() => {
        setShowPaymentMethodOptions(false);
    }, []);

    let onShowAddCreditCardRequest = useCallback(async () => {
        let paymentEnable = await props.doPaymentBizEnable();
        if (!paymentEnable) {
            return;
        }
        console.log('invoke to show creditcard entry interface through customer UI');
        // onAddCreditCard();
        onCreditCardMethodRequest && onCreditCardMethodRequest();
    }, [onCreditCardMethodRequest, props]);

    let onCancelCreditCardPayment = useCallback(() => {
        onCancelCreditCardMethodRequest && onCancelCreditCardMethodRequest();
    }, [onCancelCreditCardMethodRequest]);


    return (
        <React.Fragment>
            {browserPaymentRequestInitialized && <div className={JoinClassName(CSSStyle.main,)}>
                {
                    (browserPaymentRequestInitialized.applePayIsSupport) && (
                        <ApplyPaymentPanel interfaceLocal={local}
                            paymentRequestInfo={paymentRequestInfo}
                            onDoPayment={onApplyPayPayment}
                            onUsingCreditCardPaymentRequest={onAddCreditCard}></ApplyPaymentPanel>
                    )
                }
                {
                    !(browserPaymentRequestInitialized.applePayIsSupport) && (
                        typeof props.children === 'function' ? props.children(onShowAddCreditCardRequest) : null
                    )
                }
                {/***build credit card payment */}
                {
                    creditCardReady && <CreditCardPaymentPanel
                        showAsPopUp={true}
                        onCancelCreditCardPayment={onCancelCreditCardPayment}
                        paymentRequestInfo={paymentRequestInfo}
                        cardPaymentMethodInfo={creditCardReady}
                        onDoCreditCardPayment={onDoCreditCardPayment}
                        onAddCreditCardRequest={onAddCreditCard}
                        onChangeCreditCardRequest={onSelectPayemntMethod}
                    ></CreditCardPaymentPanel>
                }

                {
                    showPaymentMethodOptions && <PaymentMethodSelector
                        onPaymentMethodChanged={onPaymentMethodChanged}
                        applyPayEnable={(browserPaymentRequestInitialized.applePayIsSupport || browserPaymentRequestInitialized.googlePayIsSupport)}
                        onCancel={() => { onCancelPaymentMethodSelector() }}></PaymentMethodSelector>
                }
            </div>
            }
            {
                !browserPaymentRequestInitialized && <div className={JoinClassName(CSSStyle.main)}>
                    <div className={JoinClassName(CSSStyle.loading_icon)}></div>
                </div>
            }
        </React.Fragment>
    )
}
